export const RELATORIO_WITH_BASE_PATH = "/interno/relatorio-reincidencia";

export const RELATORIO_WITH_TABS = [
  {
    label: "Resumo",
    value: 0,
    slug: "resumo",
    path: `${RELATORIO_WITH_BASE_PATH}/resumo`,
  },
  {
    label: "Microgestão Campo",
    value: 1,
    slug: "microgestao-campo",
    path: `${RELATORIO_WITH_BASE_PATH}/microgestao-campo`,
  },
  {
    label: "Microgestão Atendimento",
    value: 2,
    slug: "microgestao-atendimento",
    path: `${RELATORIO_WITH_BASE_PATH}/microgestao-atendimento`,
  },
  {
    label: "Tendências & Causa-Raiz",
    value: 3,
    slug: "tendencias-causa-raiz",
    path: `${RELATORIO_WITH_BASE_PATH}/tendencias-causa-raiz`,
  },
];

export const DEFAULT_RELATORIO_WITH_TAB = RELATORIO_WITH_TABS[0];

export const getRelatorioWithTabByValue = (value) =>
  RELATORIO_WITH_TABS.find((tab) => tab.value === value) || DEFAULT_RELATORIO_WITH_TAB;

export const getRelatorioWithTabByPath = (pathname = "") => {
  const match = RELATORIO_WITH_TABS.find((tab) => pathname === tab.path);
  if (match) return match;
  if (pathname === RELATORIO_WITH_BASE_PATH || pathname === `${RELATORIO_WITH_BASE_PATH}/`) {
    return DEFAULT_RELATORIO_WITH_TAB;
  }
  return null;
};

export const buildRelatorioWithPayload = (filterData = {}) => ({
  initial_date: filterData.initialDate,
  final_date: filterData.finalDate,
  filterRegional: filterData.filtroRegional?.map((r) => r.id) || [],
  filterTecnico: filterData.filtroTecnico?.map((t) => t.id) || [],
  filterAtendente: filterData.filtroAtendente?.map((a) => a.id) || [],
});
